import styled from 'styled-components';

export default styled.div`
	--gap: 2rem;
	display: grid;
	${({ isProjectOwner }) => isProjectOwner && `grid-template-columns: 4fr 3fr;`}
	gap: var(--gap);

	/* left column */
	& > div {
		display: flex;
		flex-direction: column;
		gap: var(--spacing-x-large);
	}
	.custom-columns-aside {
		height: 100%;
		.aside-box {
			display: flex;
			flex-direction: column;
			height: 100%;
			padding: var(--gap);
			gap: var(--gap);
			.checkoption-item {
				display: flex;
				width: 100%;
				.motif-checkbox {
					display: flex;
					gap: 0.6rem;
					align-items: center;
					.motif-checkbox-label {
						margin: 0;
						width: unset;
						max-width: calc(100% - 2.2rem);
						.ellipses div {
							font-weight: 300;
						}
					}
		}
			}
		}
		.box-footer {
			flex-direction: row;
			display: flex;
			gap: var(--spacing-medium);
		}
	}
	.flex-1 {
		display: flex;
		flex: 1;
	}
`;
